<template>
  <div class="select_service_wrapper">
    <template v-if="!teamMemberData">
      <div class="row m-0">
        <div class="col-sm-6 text-left">Current Service</div>
        <div class="col-sm-6 text-right">Current Price</div>
      </div>
      <div class="row col-xs-12 m-0">
        <hr />
      </div>
      <div class="row m-0">
        <div class="col-xs-6 text-left service-header">
          <p>{{ currentService.name }}</p>
          <p class="service-description pl-10 fw-400">
            <span>Renews</span>
            {{ currentService.id === 15 ? nextOneYear : currentService.valid_until | dateFormat }}
          </p>
        </div>
        <div class="col-xs-6 text-right">
          ${{ currentService.price }}<span class="service-description"> per year</span>
        </div>
      </div>
      <div class="row col-xs-12 m-0">
        <hr />
      </div>
      <div class="row m-0">
        <div class="col-sm-6 text-left">Upgrade Service</div>
        <div class="col-sm-6 text-right">Additional Price</div>
      </div>
      <div class="row col-xs-12 m-0">
        <hr />
      </div>
      <div class="row m-0">
        <div class="col-xs-10 text-left service-header">
          <ul class="service-description pl-20">
            <template v-if="serviceSelected.id === 16">
              <li class="pb-10">Includes unlimited reports</li>
              <li class="pb-10">Upgrading will restart the clock and give a pro-rated credit</li>
            </template>
            <template v-if="selectedRecords">
              <li class="pb-10">Includes {{ selectedRecords.name }}</li>
            </template>
          </ul>
        </div>
        <div class="col-xs-2 text-right" v-if="serviceSelected.id === 16">
          +${{ serviceSelected.price - currentService.price }}
        </div>
        <div
          class="col-xs-2 text-right"
          v-if="
            (serviceSelected.id === 1 || serviceSelected.id === 13 || serviceSelected.id === 14) &&
            selectedRecords
          "
        >
          +${{ selectedRecords.price }}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row m-0 font-18 fw-400">
        <div class="col-sm-6 text-left">Current Account Add On</div>
        <div class="col-sm-6 text-right">Current Utilization</div>
      </div>
      <div class="row col-xs-12 m-0">
        <hr />
      </div>
      <div class="col-xs-12 p-0 mb-20 mt-8">
        <div class="col-xs-6 text-left service-header">
          <p>
            Total limit : <span v-if="isREP">{{ teamMemberData.total_limit - 1 }}</span
            ><span v-else>{{ teamMemberData.total_limit }}</span>
          </p>
          <p class="service-description mb-5">
            <span>Renews</span>
            {{ teamMemberData.valid_until | dateFormat }}
          </p>
        </div>
        <div class="col-xs-6 text-right font-18 fw-500">
          <span v-if="isREP">{{ teamMemberData.current_utilization - 1 }}</span
          ><span v-else>{{ teamMemberData.current_utilization }}</span>
        </div>
      </div>
      <div class="row col-xs-12 m-0">
        <hr />
      </div>
      <div class="row m-0">
        <div class="col-sm-6 text-left font-18 fw-400">Upgrade Team Members</div>
        <div class="col-sm-6 text-right font-18 fw-400">Price</div>
      </div>
      <div class="row col-xs-12 m-0">
        <hr />
      </div>
      <div class="col-xs-12 p-0 mb-20 mt-8">
        <div class="col-xs-12 p-0">
          <div class="col-xs-5 text-left service-header">
            <p>Additional team members limit : {{ selectedRecords.value }} Members</p>
          </div>
          <div class="col-xs-7 text-right font-18 fw-400">
            <template
              v-if="
                teamMemberData.total_limit <= teamMemberData.default_limit ||
                teamMemberData.isRenewal
              "
            >
              <div class="col-xs-12 p-0 text-right">
                <div class="col-xs-10 p-0">Total Price:</div>
                <div class="col-xs-2 pr-0 word-break fw-500">${{ selectedRecords.price }}</div>
              </div>
            </template>
            <template v-else>
              <div class="col-xs-12 p-0 text-right">
                <div class="col-xs-10 p-0">Actual price:</div>
                <div class="col-xs-2 pr-0 word-break fw-500">${{ selectedRecords.price }}</div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-xs-12 p-0">
          <div class="col-xs-5 text-left service-header">
            <ul>
              <li class="fw-400 text-secondary font-16">
                Charges for add-ons may be prorated to align with validity of a previous Team Member
                upgrade.
              </li>
            </ul>
          </div>
          <div class="col-xs-7 text-right font-18 fw-400">
            <div class="col-xs-12 p-0 text-right" v-if="teamMemberProRata">
              <div class="col-xs-10 p-0">Final price:</div>
              <div class="col-xs-2 pr-0 word-break fw-500">${{ teamMemberProRata.netPrice }}</div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  props: [
    'selectedRecords',
    'serviceSelected',
    'currentService',
    'teamMemberData',
    'teamMemberProRata'
  ],
  data() {
    return {
      isREP: false
    };
  },
  components: {},
  computed: {
    nextOneYear() {
      return moment().add(1, 'years').subtract('days', 1);
    },
    todayDate() {
      return moment().utc().format('YYYY-MM-DD HH:mm:ss');
    }
  },
  filters: {
    dateFormat(date) {
      return moment(date).format('MM/DD/YYYY');
    }
  },
  watch: {},
  methods: {},
  mounted() {
    this.isREP =
      JSON.parse(localStorage.getItem('userData')).account_type_id === 2 ||
      JSON.parse(localStorage.getItem('userData')).account_type_id === 4;
  }
};
</script>
<style scoped>
.select_service_wrapper {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 30px;
}
.service-header {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  padding-left: 25px;
}
.service-description {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
}

/* .fw-400 {
  font-weight: 400 !important;
} */

ul {
  padding-left: 16px;
}
</style>
